import styled from 'styled-components';

export default styled.div`
  display: flex;
  justify-content: center;
  ${({ theme }) => theme.breakpoint('sm', 'md')} {
    background-color: #fff;
  }
`;
